import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import {
  PaymentType as PaymentTypeType,
  PaymentType_payment$key,
} from '__generated__/PaymentType_payment.graphql';
import { Options, useOption } from 'lib';

export const optionsConfig: Options<PaymentTypeType> = {
  BANK_TRANSFER: {
    label: 'Pavedimas',
  },
  CASH: {
    label: 'Grynais',
  },
  PAYSERA: {
    label: 'Paysera',
  },
};

type Props = {
  payment: PaymentType_payment$key;
};

const PaymentType: FC<Props> = ({ payment }) => {
  const { type } = useFragment(
    graphql`
      fragment PaymentType_payment on Payment {
        type
      }
    `,
    payment
  );

  const { label } = useOption(type, optionsConfig);

  return <>{label}</>;
};

export default PaymentType;
